// extracted by mini-css-extract-plugin
export var lg = "_18-4";
export var md = "_18-3";
export var sm = "_18-2";
export var xs = "_18-1";
export var xxs = "_18-0";